/**
 * KFC-191 — the two stock types a hub can hold, as retained by approach A.
 *
 * A hub without a retail offer receives everything into click & collect, which is why an event
 * carrying no `stockType` at all — every event written before this ticket — reads as
 * `CLICK_AND_COLLECT`. That default is what makes the change backward compatible without a
 * data migration.
 */
export const STOCK_TYPES = {
	CLICK_AND_COLLECT: "CLICK_AND_COLLECT",
	LIBRE_SERVICE: "LIBRE_SERVICE"
}

/** The stock type an event belongs to, defaulting to click & collect for legacy events. */
export const getEventStockType = (event) => event?.data?.stockType || STOCK_TYPES.CLICK_AND_COLLECT

/**
 * KFC-351 — les issues possibles d'une demande de transfert.
 *
 * Ici plutot que dans les actions : l'action decide, le panneau traduit en message. Aucun des
 * deux n'a besoin de connaitre l'autre, et les textes restent au seul endroit qui les affiche.
 */
export const TRANSFER_REFUSALS = {
	NONE: "NONE",
	INVENTORY_DONE: "INVENTORY_DONE",
	NOT_ENOUGH_STOCK: "NOT_ENOUGH_STOCK",
	WRITE_FAILED: "WRITE_FAILED"
}

/**
 * The stock a product holds in one fridge. `undefined` covers a fridge that was never declared
 * as well as a product not loaded yet — nothing can be broken from either.
 */
export const stockForType = (productStock, stockType) => {
	if (!productStock) return undefined

	return STOCK_TYPES.LIBRE_SERVICE === stockType ? productStock.volumeLibreService : productStock.volume
}

/** A quantity is known when it is a usable number, which zero is and `undefined` is not. */
export const isKnownStock = (stock) => stock !== undefined && stock !== null

/**
 * A fridge can take a breakage only if it holds something. A fridge that was never declared and
 * one that was emptied are both refused, for the same reason: there is nothing to break.
 */
export const canBreakFrom = (productStock, stockType) => {
	const stock = stockForType(productStock, stockType)

	return isKnownStock(stock) && stock > 0
}

/** Whether anything can be broken at all: a product empty in both fridges has nothing to lose. */
export const hasAnyStockToBreak = (productStock) =>
	canBreakFrom(productStock, STOCK_TYPES.LIBRE_SERVICE)
		|| canBreakFrom(productStock, STOCK_TYPES.CLICK_AND_COLLECT)
